/** @format */
/**
 * ViewHoliday.tsx
 *
 * Pagina dedicata alla gestione delle festività.
 * Stessa struttura di ViewCalendarAnnotazioni.
 */

import React from "react";
import { Col, Row } from "antd";
import { BaseColor } from "../../../theme/maps/Colors";
import { UITitle } from "../../ui/Title";
import UITransition from "../../ui/Transition";
import { HolidayCalendar } from "./calendar";

export const ViewHoliday = (): JSX.Element => {
    return (
        <>
            <UITransition>
                <Row justify="space-between" align="middle" gutter={[16, 16]}>
                    <Col style={{ display: "inline-flex", alignItems: "baseline" }}>
                        <UITitle level={2} color={BaseColor}>
                            Festività
                        </UITitle>
                    </Col>
                </Row>

                <HolidayCalendar />

            </UITransition>
        </>
    );
};
